import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ActionsContainer from "../../../Pages/EditProduct/Components/ActionsContainer";
import Button from "@material-ui/core/Button";
import ToolbarContainer from "../../../Pages/EditProduct/Components/ToolbarContainer";
import React, {useRef, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "../../../Components/AppBar";
import SubHeader from "../../../Components/SubHeader";
import TemplatePage from "./TemplatePage";
import ToolbarContent from "../../../Pages/EditProduct/Components/ToolbarContent";
import Box from "@material-ui/core/Box";
import useComponentSize from "@rehooks/component-size";
import DrawTemplate from "../../../Components/Template/DrawTemplate";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {getPartRefIds} from "../../../../Providers/TemplateInstanceProvider";
import {Trans} from "react-i18next";

const useStyles = makeStyles(theme => ({
    mainContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    templateContainer: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px',
    },
    pageList: {
        padding: 0,
        margin: 0,
        display: 'grid',
        [theme.breakpoints.up('xs')]: {
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        [theme.breakpoints.up('sm')]: {
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        gridGap: theme.spacing(1),
        listStyle: 'none',
        '&> li': {
            paddingTop: '100%',
            position: 'relative'
        }
    }
}))

export default ({changeMenu}) => {
    const classes = useStyles();
    const [state] = useTemplateInstance();

    return <div className={classes.mainContainer}>
        <AppBar disableGutters/>
        <SubHeader onClick={() => changeMenu('main')}>Forhåndsvisning</SubHeader>

        <ul class={classes.pageList}>
            {getPartRefIds(state.template).map((partRefId, index) => {
                return <li key={partRefId}>
                    <TemplateContainer partRefId={partRefId} templateInstance={state}/>
                </li>
            })}
        </ul>

        <ActionsContainer>
            <Button color="primary" onClick={() => changeMenu('main')}><Trans>Cancel</Trans></Button>
            <Button color="primary" onClick={() => changeMenu('main')}><Trans>Done</Trans></Button>
        </ActionsContainer>
    </div>
}

const TemplateContainer = ({templateInstance, partRefId}) => {
    // Use a ref to attach to the element whose visibility you want to keep track of.
    const ref = useRef();
    // `current` points to the mounted img element.
    const size = useComponentSize(ref);

    console.log('Template instance', templateInstance);

    const classes = useStyles();
    return <div ref={ref} className={classes.templateContainer}>
        <DrawTemplate containerSize={size} templateInstance={templateInstance} partRefId={partRefId} />
    </div>
}
